import Bugsnag, { NotifiableError } from '@bugsnag/js';

export default (error: unknown) => Bugsnag.notify(error as NotifiableError);
